import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { Vendor, VendorConfig } from './vendorTypes';

export const VendorContext = createContext<{ config: VendorConfig; vendor: Vendor } | null>(null);

export const VendorProvider = ({
    config,
    vendor,
    children,
}: { config: VendorConfig; vendor: Vendor } & PropsWithChildren) => {
    const value = useMemo(() => ({ config, vendor }), [config, vendor]);

    return <VendorContext.Provider value={value}>{children}</VendorContext.Provider>;
};

export const useVendorConfig = (): VendorConfig => {
    const ctx = useContext(VendorContext);
    if (!ctx) throw new Error('VendorProvider is missing');
    return ctx.config;
};

export const useVendor = (): Vendor => {
    const ctx = useContext(VendorContext);
    if (!ctx) throw new Error('VendorProvider is missing');
    return ctx.vendor;
};
